// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/manual-sync/manual-sync.scss
// module id = 442
// module chunks = 0